'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _NotificationCTA = require('../../../molecules/notification-ribbon-cta/jsx/NotificationCTA');

var _NotificationCTA2 = _interopRequireDefault(_NotificationCTA);

var _NotificationQR = require('../../../molecules/notification-ribbon-qr/jsx/NotificationQR');

var _NotificationQR2 = _interopRequireDefault(_NotificationQR);

var _NotificationLogo = require('../../../molecules/notification-ribbon-partners/jsx/NotificationLogo');

var _NotificationLogo2 = _interopRequireDefault(_NotificationLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
This function represents configuration only for QR
and is intended to work in PageBuilder using molecules
*/
var getQRConfig = function getQRConfig(props) {
  return {
    'hidden-sm-down': props.config.type === 'NotificationQR' && !props.content.notification.config.showMobile
  };
};

var NotificationRibbon = function (_React$Component) {
  _inherits(NotificationRibbon, _React$Component);

  function NotificationRibbon(props) {
    _classCallCheck(this, NotificationRibbon);

    var _this = _possibleConstructorReturn(this, (NotificationRibbon.__proto__ || Object.getPrototypeOf(NotificationRibbon)).call(this, props));

    _this.TypeMap = {
      NotificationCTA: _NotificationCTA2.default,
      NotificationQR: _NotificationQR2.default,
      NotificationLogo: _NotificationLogo2.default
    };
    return _this;
  }

  _createClass(NotificationRibbon, [{
    key: 'render',
    value: function render() {
      var type = this.props.config.type || 'NotificationCTA';
      var Component = this.TypeMap[type];
      var id = this.props.config.id;

      var NotificationRibbonClasses = (0, _classnames2.default)('notification-ribbon theme-background-color-light', getQRConfig(this.props), this.props.className);
      return _react2.default.createElement(
        'section',
        { id: id, className: NotificationRibbonClasses, 'data-building-block': 'organism' },
        _react2.default.createElement(Component, this.props.content.notification)
      );
    }
  }]);

  return NotificationRibbon;
}(_react2.default.Component);

exports.default = NotificationRibbon;


NotificationRibbon.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['NotificationCTA', 'NotificationQR', 'NotificationLogo']).isRequired
  }),
  content: _propTypes2.default.shape({
    notification: _propTypes2.default.oneOfType([_propTypes2.default.shape(_NotificationCTA2.default.propTypes), _propTypes2.default.shape(_NotificationQR2.default.propTypes), _propTypes2.default.shape(_NotificationLogo2.default.propTypes)]).isRequired
  }),
  className: _propTypes2.default.string
};

NotificationRibbon.defaultProps = {
  config: {
    id: '',
    type: 'NotificationCTA'
  },
  content: {
    notification: _NotificationCTA2.default.defaultProps
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/notification-ribbon/jsx/NotificationRibbon.js
// module id = 1120
// module chunks = 4